 // @ts-ignore
// @ts-nocheck

 export const scanHeaders = {
  'Cache-Control': 'no-cache',
  'X-Frame-Options': 'SAMEORIGIN',
  'Content-Security-Policy': 'default-src \'self\' *.ultragaz.com.br',
  'X-Content-Type-Options': 'nosniff',
  'Strict-Transport-Security': 'max-age=16070400; includeSubDomains'
 };
